import { getAreBackordersEnabled } from '@app/ducks';
import { cn } from '@app/utils/cn';
import { getBackgroundBySwatch } from '@app/utils/getBackgroundBySwatch';
import { isDefined } from '@app/utils/is';
import { SwatchData } from '@typings';
import React from 'react';
import { useSelector } from 'react-redux';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive: boolean;
  isAvailable: boolean;
  size?: 'medium' | 'large';
  swatchData?: SwatchData;
}

export const GalleryDot = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { isActive, isAvailable, swatchData, size, ...rest } = props;
  const areBackordersEnabled = useSelector(getAreBackordersEnabled);
  const dotStyles =
    isDefined(swatchData) ?
      {
        background: getBackgroundBySwatch(swatchData),
        backgroundSize: 'cover',
      }
    : undefined;

  const buttonRef = isActive ? ref : undefined;
  const shouldShowCross = !isAvailable && !areBackordersEnabled;
  const tabIndex = isActive ? 0 : -1;

  return (
    <button
      {...rest}
      ref={buttonRef}
      tabIndex={tabIndex}
      type="button"
      className="flex h-5 shrink-0 items-center justify-center rounded-regular -outline-offset-1 focus-visible:focus-outline"
    >
      <div
        className={cn('relative h-[0.625rem] w-[0.625rem] rounded-large border border-neutral-80 transition-[width,transform,box-shadow]', {
          'dot-ring w-4': isActive,
          'scale-[0.8]': size === 'medium',
        })}
        style={dotStyles}
      >
        {shouldShowCross && (
          <div
            className={cn(
              'absolute left-1/2 top-1/2 z-elevated h-[3px] w-[0.875rem] -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded-[3px] border border-white bg-neutral-20 content-empty',
              { 'w-[18px]': isActive },
            )}
          />
        )}
      </div>
    </button>
  );
});
